<template>
  <div class="container">
    <h1>404 - siden kunne ikke findes</h1>


  </div>
</template>

<script>
export default {
  name: 'Notfound',

}
</script>
